import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';


const getDriverAPI = () => {

    return APICallingService.sendRequestForGet(url.getDriver, (res) => {
    }, true);

}

function* getDriver() {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDriverAPI);
        if (response && response?.callBackStatus.toLowerCase() == 'success') {


            yield put({
                type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVER_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {

                alert('Failed to get drivers data');
                yield put({ type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVER_API_SUCCESS, payload: { value: response?.callBackStatus } });

            }
        }
    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVER_API_SUCCESS, payload: { value: 'Failed' } });

    }


}


const getDriverByIdFun = (value) => {

    let urlGet = url.getDriverById + value.id.toString();
    return APICallingService.sendRequestForGet(urlGet, (res) => {
    }, true);

}

function* getDriverById(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDriverByIdFun, action.payload.value);
        if (response && response?.callBackStatus.toLowerCase() == 'success') {
            yield put({
                type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVERBYID_MANAGEMENT_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get drivers data ');
                yield put({ type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVERBYID_MANAGEMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }


    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVERBYID_MANAGEMENT_API_SUCCESS, payload: { value: 'Failed' } });

    }


}

const createDriverAPI = (value) => {

    let payload = {
        "firstName": value?.firstName,
        "lastName": value?.lastName,
        "isActive": true
    }

    return APICallingService.sendRequestForPostWithAuth(url.addDriver, payload, false, (res) => {

    }, true);

}

function* createDriver(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createDriverAPI, action.payload.value);

        if (response && response?.callBackStatus.toLowerCase() == 'success') {

            alert('Lots no ' + response.data.driver_id + " Added Successfully")

            yield put({
                type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVER_MANAGEMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.ADD_DRIVER_MANAGEMENT_API_CALL_SUCCESS, payload: { value: response?.callBackStatus }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to create driver user');
                yield put({ type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.ADD_DRIVER_MANAGEMENT_API_CALL_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }


    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.ADD_DRIVER_MANAGEMENT_API_CALL_SUCCESS, payload: { value: 'Failed' } });

    }


}


const editDriverAPI = (value) => {

    let urlEdit = url.editDriver + value.driver_id;

    let payload = {
        "firstName": value.firstName,
        "lastName": value.lastName,
        "isActive": true
    }

    return APICallingService.sendRequestForPut(payload, urlEdit, (res) => {
    }, true);

}

function* editDriver(action) {

    try {

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(editDriverAPI, action.payload.value);

        if (response && response != null) {

            alert('Yard no ' + response.data.driver_id + " Updated Successfully")
            yield put({
                type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVER_MANAGEMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.EDIT_DRIVER_API_SUCCESS, payload: { value: response?.callBackStatus }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to update driver user ');
                yield put({ type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.EDIT_DRIVER_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.EDIT_DRIVER_API_SUCCESS, payload: { value: 'Failed' } });

    }


}

export { editDriver, createDriver, getDriver, getDriverById };
